// @file: src/App.js
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import AuthProvider from "./actions/auth-context";
import Loading from "./components/loading/Loading";
import Navbar from "./components/navbar";
import Routes from "./Routes";
import GlobalStyle from "./styles/GlobalStyles";

function App() {
  // Usar basename apenas se estiver em produção e servido em /tv
  const basename = process.env.NODE_ENV === "production" ? "/tv" : undefined;

  return (
    <AuthProvider>
      <BrowserRouter basename={basename}>
        <GlobalStyle />
        <Loading />
        <ToastContainer hideProgressBar={false} limit={1} />
        <Navbar />
        <Routes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
